// Services.js
import React from 'react';
import aboutImg from '../assets/images/about-img-01.png';
import missionImg from '../assets/images/mission-thumb-img.png';
import visionImg from '../assets/images/vision-thumb-img.png';
import valuesImg from '../assets/images/values-thumb-img.png';
import './Pages.css';

function Services() {
  return (
    <section id="services" className='has-fixed-header py-5 pb-0'>
    <div className='container-fluid p-0 ps-0'>
      <div className="container">
        <div className="row align-items-star">
          <div className="col-md-12 col-sm-12">
              <div className='content-section'>
              <h1 className="display-6 text-primary">Our Services</h1>
                <p className="col-md-12 col-sm-12 mx-auto lead text-black">
                  Elevate offers a comprehensive range of services tailored to meet the unique challenges of risk adjustment in the healthcare industry. <br/>Explore how we can help your organization succeed.
                </p>
              </div>
          </div>
        </div>

    </div>
  </div>

  <div className='container-fluid py-4 pb-5'>
    <div className='container'>
        <div className="row">
            <div className="col-md-4 col-sm-12 text-center">
              <div className="card card-minHeight mb-4 shadow-sm py-3 px-3">
                <div className='card-header'>
                  <img src={missionImg} alt='mission image' className='img-fluid' />
                </div>
                <div className='card-info'>
                    <h3 className="card-title my-3 text-left">Risk Adjustment Analytics</h3>
                    <p className="card-text">
                    Leverage our advanced analytics tools to identify opportunities, uncover trends, and improve the accuracy of risk adjustment processes.
                    </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-12 text-center">
              <div className="card card-minHeight mb-4 shadow-sm py-3 px-3">
                  <div className='card-header'>
                    <img src={visionImg} alt='mission image' className='img-fluid' />
                  </div>
                  <div className='card-info'>
                      <h3 className="card-title my-3 text-left">Compliance Management</h3>
                      <p className="card-text">
                      Ensure adherence to healthcare regulations with our comprehensive compliance solutions tailored to your organization's needs.
                      </p>
                  </div>
                </div>
            </div>

            <div className="col-md-4 col-sm-12 text-center">
              <div className="card card-minHeight mb-4 shadow-sm py-3 px-3">
                  <div className='card-header'>
                    <img src={valuesImg} alt='mission image' className='img-fluid' />
                  </div>
                  <div className='card-info'>
                      <h3 className="card-title my-3 text-left">Data Integration</h3>
                      <p className="card-text">
                      Seamlessly integrate our solutions with your existing systems for a smooth, efficient workflow that enhances performance.
                      </p>
                  </div>
                </div>
            </div>

            <div className="col-md-4 col-sm-12 text-center">
              <div className="card card-minHeight mb-4 shadow-sm py-3 px-3">
                  <div className='card-header'>
                    <img src={valuesImg} alt='mission image' className='img-fluid' />
                  </div>
                  <div className='card-info'>
                      <h3 className="card-title my-3 text-left">Custom Reporting</h3>
                      <p className="card-text">
                      Access tailored reports that provide actionable insights, empowering you to make informed decisions with confidence.                      </p>
                  </div>
                </div>
            </div>

            <div className="col-md-4 col-sm-12 text-center">
              <div className="card card-minHeight mb-4 shadow-sm py-3 px-3">
                  <div className='card-header'>
                    <img src={valuesImg} alt='mission image' className='img-fluid' />
                  </div>
                  <div className='card-info'>
                      <h3 className="card-title my-3 text-left">End-to-End Strategy</h3>
                      <p className="card-text">
                      Partner with our experts to develop and implement end-to-end strategies that drive measurable results.
                      </p>
                      </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
              <div className="col text-center">
                <h2 className="display-6 text-primary">Why Choose Our Services?</h2>
                <p className="text-style col-md-8 col-sm-12 mx-auto">
                At Elevate, we combine cutting-edge technology with deep healthcare expertise to provide solutions that deliver real impact. From data-driven insights to seamless integration, our services are designed to empower you at every step.
                </p>
              </div>
            </div>


    </div>
  </div>

    </section>
  );
}

export default Services;